<template>
  <el-row>
    <el-col :span="24">
      <!-- <el-button
        size="medium"
        style="float:left;"
        @click="add"
        :disabled="power == 1?true:false"
      >添加</el-button> -->
      <!-- <el-button
        size="medium"
        style="float:left;"
        @click="exportData"
      >导出</el-button> -->
      <el-button
        type="primary"
        size="mini"
        style="float:left;"
        @click="getList(isExport = false)"
      >刷新</el-button>
    </el-col>
    <el-col :span="24">
      <el-table
        v-loading="pictLoading"
        :data="list"
        ref="table"
        border
        width="100%"
        height="600"
        :header-cell-style="{ background: '#2c86d1', color: 'white' }"
        :cell-style="{padding:'8px 0'}"
      >
        <el-table-column
          prop="Status"
          label="启用"
          align="center"
          width="65"
        >
          <template slot-scope="scope">
            <el-switch
              :active-value="1"
              :inactive-value="0"
              active-color="#409EFF"
              inactive-color="#dadde5"
              disabled
              v-model="scope.row.Status"
              @change=changeStatus($event,scope.row,scope.$index)
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="PtNo"
          label="点表编号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="PtName"
          label="点表名称"
          align="center"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="CtrlCode"
          label="控制码"
          align="center"
          width="90"
          :render-header="renderCtrlcode"
        >
        </el-table-column>
        <el-table-column
          prop="CloseRegNo"
          label="分寄存器号"
          align="center"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="CloseValue"
          label="分寄存器值"
          align="center"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="OpenRegNo"
          label="合寄存器号"
          align="center"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="OpenValue"
          label="合寄存器值"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="Fid"
          label="数据ID"
          align="center"
        ></el-table-column>

        <!-- <el-table-column
          label="操作"
          align="center"
          width="155"
        >
          <template slot-scope="scope">
            <el-button
              @click="handleEdit(scope.row)"
              type="primary"
              size="mini"
              :disabled="power == 1?true:false"
            >
              编辑
            </el-button>
            <el-popconfirm
              :title="`确认删除「${scope.row.YKID}」吗`"
              style="margin: 0 10px"
              @confirm="handleDelete(scope.row)"
            >
              <el-button
                slot="reference"
                size="mini"
                type="danger"
                :disabled="power == 1?true:false"
              >删除</el-button>
            </el-popconfirm>

          </template>
        </el-table-column> -->
      </el-table>
      <!-- 添加和编辑 -->
      <el-dialog
        :title="modalTitle == 1?'添加':'编辑'"
        :visible.sync="modalFlag"
        width="600px"
        @close='handleReset'
        :append-to-body="modalTemp"
        :close-on-click-modal="false"
      >
        <el-row>
          <el-form
            :model="form"
            ref="form"
            :rules="editRules"
            label-width="110px"
            class="demo-dynamic"
          >
            <el-col :span="12">
              <el-form-item
                label="点表编号"
                prop="PtNo"
              >
                <el-input
                  v-model="form.PtNo"
                  :placeholder="placeholder"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="点表名称"
                prop="PtName"
              >
                <el-input
                  v-model="form.PtName"
                  :placeholder="placeholder"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="控制码">
                <el-input
                  v-model="form.CtrlCode"
                  :placeholder="placeholder"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="数据ID">
                <el-input
                  v-model="form.Fid"
                  :placeholder="placeholder"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="分寄存器号"
                prop="CloseRegNo"
              >
                <el-input
                  v-model="form.CloseRegNo"
                  :placeholder="placeholder"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="分寄存器值">
                <el-input
                  v-model="form.CloseValue"
                  :placeholder="placeholder"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合寄存器号">
                <el-input
                  v-model="form.OpenRegNo"
                  :placeholder="placeholder"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合寄存器值">
                <el-input
                  v-model="form.OpenValue"
                  :placeholder="placeholder"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否启用">
                <el-radio-group v-model="form.Status">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="回路">
                <el-input
                  v-model="form.LoopNo"
                  :placeholder="placeholder"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button
                  type="primary"
                  @click="ok"
                >确 定</el-button>
                <el-button @click="handleReset">取 消</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </el-dialog>
    </el-col>
  </el-row>
</template>
<script>
import XLSX from "@/../static/utils/xlsx/xlsx.core.min";
import { xlsx } from "../../../common/utils";
import { mapGetters } from "vuex";
export default {
  props: {
    item: String,
    power: Number,
    Value: Object,
    // IsAdd: Boolean,
    // IsEdit: Boolean,
    // IsDelete: Boolean,
  },
  watch: {
    item(newData, oldData) {
      this.getList(newData);
    },
  },
  data() {
    return {
      pictLoading: true,
      modalTitle: 1, //1、添加  2、编辑
      modalFlag: false,
      modalTemp: true,
      placeholder: "请输入",
      tableHeight: 600,

      form: {
        PtNo: "",
        PtName: "",
        CtrlCode: "",
        Fid: "",
        CloseRegNo: "",
        CloseValue: "",
        OpenRegNo: "",
        OpenValue: "",
        LoopNo: "",
        Status: 1,
        Remark: "",
      },
      editRules: {
        PtNo: [
          {
            required: true,
            message: "点表编号不能为空",
            trigger: "blur",
          },
        ],
        PtName: [
          {
            required: true,
            message: "点表名称不能为空",
            trigger: "blur",
          },
        ],
        CloseRegNo: [
          {
            required: true,
            message: "分寄存器号不能为空",
            trigger: "blur",
          },
        ],
        Fid: [
          {
            required: true,
            message: "数据ID不能为空",
            trigger: "blur",
          },
        ],
      },
      list: [],
    };
  },
  computed: {
    ...mapGetters(["SessionId", "UserId"]),
  },

  mounted() {
    this.getList();
  },
  methods: {
    // 为表格头标题添加小图标并hover后出现提示信息
    renderCtrlcode(h, { column, $index }) {
      // h 是一个渲染函数       column 是一个对象表示当前列      $index 第几列
      return h("div", [
        h("span", column.label + "  ", {
          align: "center",
          marginTop: "10px",
        }),
        h(
          "el-popover",
          {
            props: {
              placement: "top-start", // 一般 icon 处可添加浮层说明，浮层位置等属性
              width: "260",
              trigger: "hover",
            },
          },
          [
            h(
              "p",
              "控制码modbus(03 04) DLT(无)CJT/188(填仪表类型,冷水10,热水11,热量表20,燃气30)",
              {
                class: "text-align: center; margin: 0",
              }
            ),
            h("i", {
              // 生成 i 标签 ，添加icon 设置 样式，slot 必填
              class: "el-icon-question",
              style: "color:#ccc,margin:18px,padding-top:10px",
              slot: "reference",
            }),
          ]
        ),
      ]);
    },
    setData() {
      return {
        SessionId: this.Value.SessionId,
        UserId: this.Value.UserId,
        ClientName: this.Value.ClientName,
        MenuID: this.$route.query[0],
        Params: {
          // PageNumber: 0,
          // PageSize: 0,
          // SearchList: [],
          // SortList: []
        },
      };
    },
    // 版本列表
    async getList(isExport = false) {
      let data = this.setData();
      data.Params = {
        SortList: [
          {
            SortDescend: false,
            SortProperty: "PtNo",
          },
        ],
        SearchList: [
          {
            CompareType: "Equal",
            PropertyName: "ProtocolID",
            PropertyValue: this.item,
          },
        ],
      };
      const res = await this.$api.axios_http(
        this.$gd.admin.template.ProTempYKLibGetList,
        data,
        "POST"
      );
      if (res.ReturnCode == 0) {
        this.pictLoading = false;
        if (!isExport) {
          this.list = res.ReturnList;
        } else {
          let data = {
            Status: "启用",
            PtNo: "点表编号",
            PtName: "点表名称",
            CtrlCode: "控制码",
            CloseRegNo: "分寄存器号",
            CloseValue: "分寄存器值",
            OpenRegNo: "合寄存器号",
            OpenValue: "合寄存器值",
            Fid: "数据ID",
          };
          this.list.forEach((item) => {
            if (item.Status == 1) {
              item.Status = "是";
            } else {
              item.Status = "否";
            }
          });
          let arr = [
            "启用",
            "点表编号",
            "点表名称",
            "控制码",
            "分寄存器号",
            "分寄存器值",
            "合寄存器号",
            "合寄存器值",
            "数据ID",
          ];
          xlsx(this.list, data, "遥控点表.xlsx", arr);
          this.list = res.ReturnList;
        }
      } else {
        this.$message.error(res.Error);
      }
    },
    // 禁用启用
    async changeStatus(e, row, index) {
      const data = {
        SessionId: this.Value.SessionId,
        UserId: this.Value.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          YKID: row.YKID,
          Status: row.Status,
        },
      };
      const res = await this.$api.axios_http(
        this.$gd.admin.template.ProTempYKLibEnable,
        data,
        "POST"
      );
      if (res.ReturnCode == 0) {
        if (row.Status == 0) {
          this.$message({
            message: "禁用成功",
            type: "success",
          });
        } else {
          this.$message({
            message: "开启成功",
            type: "success",
          });
        }
        setTimeout(() => {
          this.getList();
        }, 1000);
      } else {
        this.$message.error(res.Error);
      }
    },
    // 列表添加
    add() {
      this.modalFlag = true;
      this.modalTitle = 1;
      // this.form = {
      //     PtNo: "",
      //     Remark: "",
      //     PtName: "",
      //     RegNo1: "",
      //     AddCode: "",
      //     LoopNo: '',
      //     CtrlCode: '03',
      //     valueOn: "",
      //     valueOff: "",
      // }
    },
    // 列表编辑
    handleEdit(item, index) {
      // console.log(item);
      this.modalFlag = true;
      this.modalTitle = 2;
      this.form = JSON.parse(JSON.stringify(item));
    },
    // 添加编辑-提交按钮
    async ok() {
      let obj = {
        SessionId: this.Value.SessionId,
        UserId: this.Value.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: { ...this.form },
      };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
      let res;
      // 添加
      if (this.modalTitle == 1) {
        res = await this.$api.axios_http(
          this.$gd.admin.template.ProTempYKLibAdd,
          obj,
          "POST"
        );
      } else {
        res = await this.$api.axios_http(
          this.$gd.admin.template.ProTempYKLibEdit,
          obj,
          "POST"
        );
      }
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.modalFlag = false;
        this.handleReset();
        this.getList();
      } else {
        this.$message.error(res.Error);
      }
    },
    handleReset() {
      this.modalFlag = false;
      this.form.PtNo = "";
      this.form.PtName = "";
      this.form.CtrlCode = "";
      this.form.Fid = "";
      this.form.CloseRegNo = "";
      this.form.LoopNo = "";
      this.form.CloseValue = "03";
      this.form.OpenRegNo = "";
      this.form.OpenValue = "";
      this.form.Remark = "";
      this.form.Status = "";
    },
    handleUrl(sefUrl, data, type, btnType) {
      this.$api
        .axios_http(sefUrl, data, type)
        .then((res) => {
          if (btnType == 2) {
            this.handleReset();
          }
          this.$message({
            type: "success",
            message: "操作成功!",
            customClass: "center",
          });
          this.getList();
        })
        .catch((e) => {
          this.$message.error({
            showClose: true,
            message: e.data.Error,
            customClass: "center",
          });
        });
    },
    // 删除
    //遥控点表--删除
    async handleDelete(vm) {
      let data = {
        SessionId: this.Value.SessionId,
        UserId: this.Value.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          YKID: vm.YKID,
        },
      };
      const res = await this.$api.axios_http(
        this.$gd.admin.template.ProTempYKLibDel,
        data,
        "POST"
      );
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.getList();
      } else {
        this.$message.error(res.Error);
      }
    },
    exportData() {
      this.getList(true);
    },
  },
  watch: {
    item(newData, oldData) {
      if (newData != oldData) {
        this.getList();
      }
    },
  },
  beforeUpdate() {
    this.$nextTick(() => {
      //在数据加载完，重新渲染表格
      this.$refs.table.doLayout();
    });
  },
};
</script>
<style>
/*头部th*/
.ivu-table-header th {
  color: #fff;
  font-weight: bold;
  background-color: #66809d;
  /* border: none; */
}

.ivu-table th {
  color: #fff;
  background-color: #66809d;
}
</style>
